import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !token) {
      navigate('/auth');
    }
  }, [token, loading, navigate]);

  if (loading) return <div className="min-h-screen bg-[#0B0B0C] flex items-center justify-center text-white">Loading...</div>;
  if (!token) return null;

  return children;
};

export default ProtectedRoute;
